import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// @atlaskit
// import SectionMessage from '@atlaskit/section-message';
import { Grid, GridColumn } from '@atlaskit/page';
import Button, { ButtonGroup } from '@atlaskit/button';
import Select from '@atlaskit/select';
import Spinner from '@atlaskit/spinner';

// @source
import { Header, ExcelViewer, DownloadDropdownMenu } from './components';
import {
  Messages, Fragment, QueryBuilder, ConvertQuery,
} from '../../components';
import { Report as APIs } from '../../../server';
import Layout from '../../templates/Layout';
import * as Styled from './styled';
import ChatPage from '../../components/Chat/Chat';

const initialState = {
  columns: [],
  isDisabled: true,
  isExcelViewer: false,
  isLoading: false,
  message: false,
  isAi: false,
};

const initialStatic = {
  report: '',
  query: '',
};

class Excel extends React.Component {
  constructor(props) {
    super(props);
    this.state = initialState;
    this.static = initialStatic;
    this.unmount = false;
    this.onChangeHandle = this.onChangeHandle.bind(this);
    this.onCloseMessage = this.onCloseMessage.bind(this);
    this.onToggleExcelViewer = this.onToggleExcelViewer.bind(this);
    this.onToggleAiViewer = this.onToggleAiViewer.bind(this);
    this.outputUpdater = this.outputUpdater.bind(this);
  }

  componentWillMount() {
    if (!this.props.reports.override) {
      this.fetchReportList();
    }
  }

  componentWillUnmount() {
    this.unmount = true;
  }

  onChangeHandle(option) {
    this.fetchReportColumns(option.value);
  }

  onToggleAiViewer() {
    const { isAi } = this.state;
    this.setState({
      isAi: !isAi,
    });
  }

  onToggleExcelViewer() {
    this.setState({
      isExcelViewer: !this.state.isExcelViewer,
    });
  }

  onCloseMessage() {
    this.setState({
      message: false,
    });
  }

  setStateUnmount(state) {
    if (this.unmount) return;
    this.setState(state);
  }

  setStatic(state) {
    this.static = { ...this.static, ...state };
  }

  outputUpdater(template) {
    const query = ConvertQuery(template);

    if (query !== this.static.query) {
      this.setStatic({ query });
      this.setState({ isDisabled: query.length < 5 });
    }
  }

  fetchReportList() {
    APIs.fetch({
      // eslint-disable-next-line react/destructuring-assignment
      dispatch: this.props.dispatch,
      error: (messages) => {
        this.setStateUnmount({
          message: (
            <Messages
              items={messages}
              onClose={this.onCloseMessage}
            />
          ),
        });
      },
    });
  }

  fetchReportColumns(report) {
    this.setState({
      columns: [],
      isDisabled: true,
      isLoading: true,
    });
    this.setStatic({
      query: '',
      report,
    });

    APIs.columns({
      data: { report },
      success: (columns) => {
        this.setStateUnmount({
          isLoading: false,
          columns,
        });
      },
      error: (messages) => {
        this.setStateUnmount({
          message: (
            <Messages
              items={messages}
              onClose={this.onCloseMessage}
            />
          ),
        });
      },
    });
  }

  render() {
    const { outerWidth } = window;

    return (
      <Layout>
        <meta name="viewport" content="width=device-width, initial-scale=1.0, user-scalable=0" />
        <Grid>
          <GridColumn>
            <Header />
            <Select
              placeholder="Select a report"
              isLoading={!this.props.reports.override}
              options={this.props.reports.data.map(item => ({
                label: item.Name,
                value: item.Name,
              }))}
              onChange={this.onChangeHandle}
            />
            <Fragment render={this.state.columns.length}>
              <QueryBuilder
                isMobile={outerWidth < 768}
                fields={this.state.columns.map(elem => ({
                  name: elem.ColumnName,
                  type: elem.ColumnType,
                }))}
                output={this.outputUpdater}
              />
            </Fragment>
            <Fragment render={this.state.isLoading}>
              <Styled.SpinnerColumns>
                <Spinner />
              </Styled.SpinnerColumns>
            </Fragment>
            <Styled.ButtonGroup>
              <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                <ButtonGroup>
                  <DownloadDropdownMenu
                    model={{
                      report: this.static.report,
                      query: this.static.query,
                    }}
                    isDisabled={this.state.isDisabled}
                  />
                  <Button
                    appearance="primary"
                    isDisabled={this.state.isDisabled}
                    onClick={this.onToggleExcelViewer}
                  >
                  View here
                  </Button>
                </ButtonGroup>
                <div id="chat-controls-portal" />
              </div>
            </Styled.ButtonGroup>
            {this.state.message}
          </GridColumn>
          <ChatPage reportId={this.static.report} query={this.static.query} />
        </Grid>
        <Fragment render={this.state.isExcelViewer}>
          <ExcelViewer
            model={{
              report: this.static.report,
              query: this.static.query,
            }}
            onClose={this.onToggleExcelViewer}
            query={this.static.query}
            report={this.static.report}
          />
        </Fragment>
      </Layout>
    );
  }
}

Excel.propTypes = {
  dispatch: PropTypes.func.isRequired,
  reports: PropTypes.shape().isRequired,
};

const mapStateToProps = state => ({
  reports: state.Report,
});

export default connect(mapStateToProps)(Excel);
